import { render } from "./DbTableForm.vue?vue&type=template&id=7d1cdebe"
import script from "./DbTableForm.vue?vue&type=script&lang=js"
export * from "./DbTableForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__